import axios from 'axios'

export default {
  get() {
    return axios.get('/profile').then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  set(data) {
    return axios.post('/profile', data).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  changePassword(data) {
    return axios.post('/profile/changePassword', data).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
}
